import React from "react";


class Panel extends React.Component {

    
    render(){
        console.log()
        return <div className={'tab'+ this.props.index}>{this.props.children}</div>
      }

}

export default Panel;